import { ProductsDataProps } from '../../../../utils/types';

export const shouldRenderTermsButton = (productData: ProductsDataProps) => {
  if (productData.operationType === 'sell') {
    return false;
  }
  return (
    productData.marketType === 'FixedIncome' ||
    productData.marketType === 'Fund' ||
    productData.marketType === 'COE'
  );
};

export const getObservation = (productData: ProductsDataProps) => {
  if (productData.marketType === 'Equity') {
    return 'Obs: Os valores apresentados nesta pré-boleta estão sujeitos a variações de mercado e não contemplam custos operacionais como corretagem, emolumentos ou outros.';
  }
  if (productData.operationType === 'sell') {
    return '** A data informada é uma previsão de liquidação e pode sofrer alteração. Acompanhe a atualização  através do seu app.';
  }
  if (productData.marketType === 'Treasury') {
    return 'Obs: A ordem enviada está sujeita ao fechamento de mercado.';
  }
};
